import { Component, SimpleChanges } from '@angular/core';
import { LoadingController, NavController} from '@ionic/angular';
import { EventProvider, EventDetailsModel, EventTievts } from '../../providers/event/event';
import { ResultProvider } from '../../providers/result/result';
import { LoaderProvider } from '../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { ContainerWithItems } from '../container-with-items/container-with-items';
import areas from '../../assets/data/area/area';
import { EventListPage } from '../../pages/event/event-list/event-list';
import { SettingsProvider } from '../../providers/settings/settings';
import { Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';

@Component({
    selector: 'events-block-with-containers',
    templateUrl: 'events-block-with-containers.html',
    styleUrls:['./events-block-with-containers.scss']
})
export class EventsBlockWithContainersComponent {
    containers: ContainerWithItems [] = [];
    private readonly INTERNATIONAL_AREA = 'international'
    limitedPagination = {
        limit: 5,
        page: 1,
        start: 0
    };
    lang:string = '';
    constructor(public navCtrl: NavController,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public settingsService:SettingsProvider,
        private router:Router,
        private navService:NavigationService
    ) { }

    ngOnInit(){
        this.initLangAndEventByLang();
    }
    initLangAndEventByLang(){
        this.lang =  this.translate.getDefaultLang()
        this.collectOverviewEvents();
    }
    /**
     * initializes the containers with the events according to the area
     */
    collectOverviewEvents() {
        return new Promise((resolve, reject) => {
            if(this.lang == 'en'){
                this.limitedPagination = {
                    limit:20,
                    page:1,
                    start:0
                }
            }       
            const promises = areas.map((area: string, index) => {
                return this.getEventsByEventTypeEventArea(this.eventService.activeEventType, area, {page: 1, start: 0, limit: 30}).then((uniqueEvents: any) => {
                    return {
                        eventArea: area,
                        eventType: this.eventService.activeEventType,
                        items: uniqueEvents
                    };
                });
            });

            Promise.all(promises).then((containers: any) => {
                this.containers = containers.sort((a, b) => a.eventArea.localeCompare(b.eventArea));
                for(let i=0; i<this.containers.length; i++){
                    if(this.containers[i].eventArea==this.INTERNATIONAL_AREA){
                        let internationalContainer = this.containers.splice(i, 1)[0]
                        this.containers.push(internationalContainer);
                    }
                }
                    if(this.lang == 'en'){
                        this.containers = containers.filter(container => container.eventArea==this.INTERNATIONAL_AREA)
                    }
                console.log('this.containers', this.containers)
                resolve(this.containers);
            });
        });
    }

    onExpandContainer(containerWithItems: ContainerWithItems){
        this.eventService.getEventSimple(containerWithItems.eventType, containerWithItems.eventArea, {page: 1, start: 0, limit: 20}).then(events => {
            let uniqueEvents = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
            let container = {
                eventType: containerWithItems.eventType,
                eventArea: containerWithItems.eventArea,
                items: uniqueEvents
            };
            console.log('container', container)
            this.navCtrl.navigateForward('/tab1/event/list', {state:{container}})
            // (this.app.getRootNav() as NavController).push(EventListPage, {container: container })
        });
    
    }

    getEventStatus(event: EventTievts) {
        if (typeof event === "undefined") return "";
        let status = event.eventStatus;
        if (status =="C") return this.translate.instant('EVENT_CANCELLED');
        else if (status =="N") return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }

    getEventsByEventTypeEventArea(eventType: string, eventArea: string, pagination: any){
        return new Promise((resolve, reject) => {
            this.eventService.getEventSimple(eventType, eventArea, pagination).then(events => {
                let uniqueEvents = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
                uniqueEvents = uniqueEvents.slice(0, this.limitedPagination.limit);
                resolve(uniqueEvents);
            });
        })
    }

    async openEventDetails(_event) {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(_event.eventName, _event.ort, _event.dateFormatted, _event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {

                if (event.name.length < 1) {
                    this.openEventDetails(_event);
                    loader.dismiss();
                } else {
                    this.navCtrl.navigateForward('/tab1/event/details/tabs', {state:{event}}).then(() => {
                        loader.dismiss()
                    });
                    // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }
}
